import { useSelector } from 'react-redux';
import { modalWindowsMapping } from './mapping';
import { getModalsState } from './selectors';
export function ModalWindows() {
    const { type } = useSelector(getModalsState);
    return type ? modalWindowsMapping[type] : null;
}
